import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//
import enLocales from './en.json';
import jaLocales from './ja.json';

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      ja: { translations: jaLocales },
    },
    lng: localStorage.getItem('i18nextLng') || 'ja',
    fallbackLng: 'ja',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
    // MFA対応 start --------------
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'li', 'ul'],
    },
    // MFA対応 end --------------
  });

export default i18n;
